var map = {
	"./blood-group/blood-group.module": [
		"./src/app/blood-group/blood-group.module.ts",
		"default~blood-group-blood-group-module~calendar-calendar-module~components-components-module~notific~96ca9801",
		"blood-group-blood-group-module"
	],
	"./calendar/calendar.module": [
		"./src/app/calendar/calendar.module.ts",
		"default~blood-group-blood-group-module~calendar-calendar-module~components-components-module~notific~96ca9801",
		"calendar-calendar-module"
	],
	"./charts/charts.module": [
		"./src/app/charts/charts.module.ts",
		"charts-charts-module"
	],
	"./components/components.module": [
		"./src/app/components/components.module.ts",
		"default~blood-group-blood-group-module~calendar-calendar-module~components-components-module~notific~96ca9801",
		"components-components-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./donations/donations-table/donations.module": [
		"./src/app/donations/donations-table/donations.module.ts",
		"donations-donations-table-donations-module"
	],
	"./faculty/faculty.module": [
		"./src/app/faculty/faculty.module.ts",
		"faculty-faculty-module"
	],
	"./forms/forms.module": [
		"./src/app/forms/forms.module.ts",
		"forms-forms-module"
	],
	"./maps/maps.module": [
		"./src/app/maps/maps.module.ts",
		"maps-maps-module"
	],
	"./material-dashboard/material-dashboard.module": [
		"./src/app/material-dashboard/material-dashboard.module.ts",
		"material-dashboard-material-dashboard-module"
	],
	"./notifications-table/notifications.module": [
		"./src/app/notifications-table/notifications.module.ts",
		"default~blood-group-blood-group-module~calendar-calendar-module~components-components-module~notific~96ca9801",
		"common",
		"notifications-table-notifications-module"
	],
	"./public/public.module": [
		"./src/app/public/public.module.ts",
		"public-public-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"reports-reports-module"
	],
	"./reservations/reservations.module": [
		"./src/app/reservations/reservations.module.ts",
		"default~blood-group-blood-group-module~calendar-calendar-module~components-components-module~notific~96ca9801",
		"reservations-reservations-module"
	],
	"./tables/tables.module": [
		"./src/app/tables/tables.module.ts",
		"tables-tables-module"
	],
	"./timeline/timeline.module": [
		"./src/app/timeline/timeline.module.ts",
		"timeline-timeline-module"
	],
	"./userpage/user.module": [
		"./src/app/userpage/user.module.ts",
		"userpage-user-module"
	],
	"./widgets/widgets.module": [
		"./src/app/widgets/widgets.module.ts",
		"widgets-widgets-module"
	],
	"./zavod-users/zavod-users.module": [
		"./src/app/zavod-users/zavod-users.module.ts",
		"default~blood-group-blood-group-module~calendar-calendar-module~components-components-module~notific~96ca9801",
		"common",
		"zavod-users-zavod-users-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;